import { sounds, type SoundType } from './sounds';

class AudioManager {
  private cache = new Map<SoundType, HTMLAudioElement>();
  private muted = false;
  private masterVolume = 1;

  constructor() {
    this.preload();
  }

  private preload() {
    (Object.keys(sounds) as SoundType[]).forEach((key) => {
      const audio = new Audio(sounds[key].src);
      audio.preload = 'auto';

      this.cache.set(key, audio);
    });
  }

  play(type: SoundType) {
    if (this.muted) return;

    const config = sounds[type];
    if (!config) return;

    const audio = new Audio(config.src);

    audio.volume = (config.volume ?? 1) * this.masterVolume;
    audio.currentTime = 0;

    audio.play().catch(() => {});
  }

  stop(type: SoundType) {
    const audio = this.cache.get(type);
    if (!audio) return;

    audio.pause();
    audio.currentTime = 0;
  }

  stopAll() {
    this.cache.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
    });
  }

  mute() {
    this.muted = true;
  }

  unmute() {
    this.muted = false;
  }

  toggleMute() {
    this.muted = !this.muted;
  }

  isMuted() {
    return this.muted;
  }

  setVolume(volume: number) {
    this.masterVolume = Math.max(0, Math.min(1, volume));
  }

  getVolume() {
    return this.masterVolume;
  }
}

export const audioManager = new AudioManager();
